import { useRoutes } from 'react-router';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useIdleTimer } from 'react-idle-timer';

import routes from './routes';

/* AUTH */

/**
 * AppRouter Component
 *
 * Component for handling routing in the application.
 * Uses authentication status and Microsoft Authentication Library (MSAL) instance.
 * Also includes an idle timer for automatic logout.
 * @component
 * @returns {JSX.Element} The rendered AppRouter component.
 */
export default function AppRouter(): JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const router = useRoutes(routes);

  useIdleTimer({
    timeout: 1000 * 60 * 15, // 15 minutos (esto se debe modificar cuando se tengan los datos de admin)
    crossTab: true,
    syncTimers: 200,
    name: 'logout-timer',
    onIdle: () => isAuthenticated && instance.logout()
  });

  return router;
}
